class CustomMenuDrawer {
  constructor() {
    this.menuButton = document.getElementById('custom-menu-button');
    this.menuDrawer = document.getElementById('custom-menu-drawer');
    this.menuOverlay = document.getElementById('custom-menu-overlay');
    this.menuIcon = this.menuButton.querySelector('.menu-icon');
    this.closeIcon = this.menuButton.querySelector('.close-icon');
    this.isOpen = false;

    this.init();
  }

  init() {
    this.menuButton.addEventListener('click', this.toggleMenu.bind(this));
    this.menuOverlay.addEventListener('click', this.toggleMenu.bind(this));
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
    
    if (this.isOpen) {
      this.menuDrawer.classList.add('is-open');
      this.menuOverlay.classList.add('is-open');
      this.menuIcon.classList.add('menu-open');
      this.menuIcon.style.display = 'none';
      this.closeIcon.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    } else {
      this.menuDrawer.classList.remove('is-open');
      this.menuOverlay.classList.remove('is-open');
      this.menuIcon.classList.add('menu-open');
      this.menuIcon.style.display = 'block';
      this.closeIcon.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    }
  }

  handleOutsideClick(event) {
    if (this.isOpen && 
        !this.menuDrawer.contains(event.target) && 
        !this.menuButton.contains(event.target)) {
      this.toggleMenu();
    }
  }
}

// Initialize the custom menu drawer when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CustomMenuDrawer();
}); 